import { useMemo } from "react";

import createContextFactory from "@/utils/factory";

const { Provider, useContext } = createContextFactory(({ field }) => useMemo(() => ({ field }), [field]))

export {
    Provider as FormFieldProvider,
    useContext as useFormFieldContext,
}
